import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { useModal } from 'reservations/base/providers/ModalProvider';
import {
  FINAL_SCREEN_HEADER,
  FINAL_SCREEN_SUBHEADER
} from 'reservations/checklessPayments/constants';

const EnrollmentCompleteModal = () => {
  const { close } = useModal();

  return (
    <BaseDrawer
      header={FINAL_SCREEN_HEADER}
      subheader={FINAL_SCREEN_SUBHEADER}
      primaryButton={{ label: 'DONE', onClick: close }}
    />
  );
};

export default EnrollmentCompleteModal;
